
import { defineComponent } from 'vue';
import { mapState, mapActions } from 'pinia';
import CustomMultiSelect from '@/components/ui/CustomMultiSelect.vue';
import { useStore } from '@/plugins/store/index';
import { Region } from '@/types';

export default defineComponent({
    components: { CustomMultiSelect },
    data() {
        return {
            chosenPartnerRegions: [] as Region[],
        };
    },
    computed: {
        ...mapState(useStore, ['regions', 'partnerRegions']),
        selectableRegions(): Region[] | undefined {
            return this.regions?.slice(1).filter((currentRegion) => currentRegion.excludeFromSorting !== true);
        },
    },
    watch: {
        partnerRegions: {
            handler() {
                if (Array.isArray(this.partnerRegions)) {
                    this.chosenPartnerRegions = this.selectableRegions?.filter((region) => (this.partnerRegions as string[])?.includes(region.id)) ?? [];
                }
            },
            immediate: true,
        },
    },
    methods: {
        ...mapActions(useStore, ['setPartnerRegions']),
        async onSaveClicked() {
            await this.setPartnerRegions(this.chosenPartnerRegions.map((region) => region.id));
            window.location.reload();
        },
    },
});
